<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/school-history/${inputs.id}`
						: `transaction/school-history`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_school_name" class="col-sm-3 mb-0">
						School Name
					</label>
					<app-input
						id="inputs_school_name"
						class="col-sm-9"
						placeholder="School Name"
						type="search-select"
						:required="true"
						:list="schoolNameLists"
						v-model="inputs.school_id"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_school_level" class="col-sm-3 mb-0">
						School Level
					</label>
					<app-input
						id="inputs_school_level"
						class="col-sm-9"
						placeholder="School Level"
						type="search-select"
						:required="true"
						:list="schoolLevelLists"
						v-model="inputs.school_level_id"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_is_chinese_lesson" class="col-sm-3 mb-0">
						Have Chinese Lesson at School
					</label>
					<app-input
						id="inputs_is_chinese_lesson"
						class="col-sm-9"
						type="radio"
						v-model="inputs.is_chinese_lesson"
						:list="isChineseLessonLists"
						placeholder="Chinese Lesson at School"
					/>
				</div>

				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "SchoolHistoryTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			modalId: this.formId,
			modalTitle: this.$t("add"),
			schoolNameLists: [],
			schoolLevelLists: [],
			isChineseLessonLists: [
				{ id: 0, value: "No" },
				{ id: 1, value: "Yes" },
			],
			input_school_name: this.value
				? this.value.school
					? {
							id: this.value.school.id || 0,
							name: this.value.school.name || "",
							code: this.value.school.code,
							is_active: this.value.school.is_active,
					  }
					: {
							id: this.value.school?.id || 0,
							name: this.value.school?.name || "",
							code: this.value.school?.code,
							is_active: this.value.school?.is_active,
					  }
				: {
						id: this.value.school.id || 0,
						name: this.value.school.name || "",
						code: this.value.school.code,
						is_active: this.value.school.is_active,
				  },
			input_school_level: this.value
				? this.value.school_level
					? {
							id: this.value.school_level.id || 0,
							name: this.value.school_level.name || "",
							code: this.value.school_level.code,
							is_active: this.value.school_level.is_active,
					  }
					: {
							id: this.value.school_level?.id || 0,
							name: this.value.school_level?.name || "",
							code: this.value.school_level?.code,
							is_active: this.value.school_level?.is_active,
					  }
				: {
						id: this.value.school_level.id || 0,
						name: this.value.school_level.name || "",
						code: this.value.school_level.code,
						is_active: this.value.school_level.is_active,
				  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let [schoolNameResponse, schoolLevelResponse] =
					await Promise.all([
						axios.get("/master/school?per_page=50"),
						axios.get("/master/school-level?per_page=50"),
					]);

				schoolNameResponse.data.data.forEach((item) => {
					this.schoolNameLists.push({
						id: item.id,
						value: item.name,
					});
				});

				schoolLevelResponse.data.data.forEach((item) => {
					this.schoolLevelLists.push({
						id: item.id,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},
		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.input_school_name = {
				id: this.inputs.school_list.id || 0,
				name: this.inputs.school_list.name || "",
				code: this.inputs.school_list.code,
				is_active: this.inputs.school_list.is_active,
			};
			this.input_school_level = {
				id: this.inputs.school_level_list.id || 0,
				name: this.inputs.school_level_list.name || "",
				code: this.inputs.school_level_list.code,
				is_active: this.inputs.school_level_list.is_active,
			};
			this.preloader = false;
		},
		setSchoolName(data) {
			this.inputs.school_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.school_id = data.id;
			}
		},
		setSchoolLevel(data) {
			this.inputs.school_level_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.school_level_id = data.id;
			}
		},
	},
};
</script>
